var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"magnify-toggle",on:{"click":function($event){return _vm.$emit('handleClick')}}},[(_vm.active)?_c('MagnifyIconActive'):_c('MagnifyIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }